import baniotermostatico1 from '../baniotermostatico/baniotermostatico1.png'

const baniotermostaticoImages = [
    baniotermostatico1,
]

export default baniotermostaticoImages